import { createFileRoute } from "@tanstack/react-router"
import { MaterialsOverviewReport } from "@/features/reports/components/MaterialsOverviewReport"
import {
  applyMaterialsOverviewDefaults,
  materialsOverviewQuery,
  MaterialsOverviewSearchParams,
} from "@/features/reports/core/hooks/useMaterialsOverviewReport"

export const Route = createFileRoute("/(authenticated)/reports/materials-overview")({
  validateSearch: MaterialsOverviewSearchParams,
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps: search }) => {
    void context.queryClient.ensureQueryData(
      materialsOverviewQuery(applyMaterialsOverviewDefaults(search)),
    )
  },
  component: MaterialsOverviewReport,
})
